import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface GlobalPaywallStatus {
  enabled: boolean;
  isActive: boolean;
  lastUpdated: string;
  environment: string;
}

export function useGlobalPaywall() {
  return useQuery({
    queryKey: ['global-paywall'],
    queryFn: () => apiClient<GlobalPaywallStatus>('/global-paywall'),
  });
}

export function useSetGlobalPaywall() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (enabled: boolean) =>
      apiClient<GlobalPaywallStatus & { message: string }>('/global-paywall', {
        method: 'POST',
        body: JSON.stringify({ enabled }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['global-paywall'] }),
  });
}
